import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import './Forms.css';

// Textos y destino segun el tipo de cuenta que se registra.
const ROLE_CONFIG = {
  worker: {
    title: 'Crear cuenta de trabajador',
    subtitle: 'Registrate como obrero o maestro de obra y consigue mas clientes.',
    redirect: '/mi-perfil',
  },
  client: {
    title: 'Crear cuenta de cliente',
    subtitle: 'Registrate para contactar maestros y publicar tus necesidades.',
    redirect: '/',
  },
};

const Register = ({ role = 'client' }) => {
  const navigate = useNavigate();
  const { register, googleLogin } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const config = ROLE_CONFIG[role] || ROLE_CONFIG.client;
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    phone: '',
    whatsapp_quote_opt_in: false,
    password: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };

  const handleGoogle = async (resp) => {
    setError('');
    if (role === 'worker' && form.phone.replace(/\D/g, '').length < 9) {
      setError('Ingresa un número de WhatsApp válido para recibir cotizaciones.');
      return;
    }
    try {
      await googleLogin(resp.credential, role, form.phone, form.whatsapp_quote_opt_in);
      navigate(config.redirect);
    } catch (err) {
      setError('No se pudo registrar con Google.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register({ ...form, role });
      navigate(config.redirect);
    } catch (err) {
      const data = err.response?.data;
      const msg = data
        ? Object.entries(data).map(([k, v]) => `${k}: ${v}`).join(' · ')
        : 'No se pudo completar el registro.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page">
      <div className="form-wrap">
        <div className="form-card">
          <div className="form-head">
            <h1>{config.title}</h1>
            <p>{config.subtitle}</p>
          </div>
          {error && <div className="form-alert error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Nombres *</label>
                <input name="first_name" value={form.first_name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Apellidos *</label>
                <input name="last_name" value={form.last_name} onChange={handleChange} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Usuario *</label>
                <input name="username" value={form.username} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>{role === 'worker' ? 'WhatsApp para recibir cotizaciones *' : 'Teléfono / WhatsApp'}</label>
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required={role === 'worker'}
                  autoComplete="tel"
                  placeholder="+51 913 412 527"
                />
              </div>
            </div>
            <div className="form-group">
              <label>Correo *</label>
              <input type="email" name="email" value={form.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Contraseña * (mínimo 8 caracteres)</label>
              <input type="password" name="password" value={form.password} onChange={handleChange} required minLength={8} />
            </div>
            {role === 'worker' && (
              <div className="form-group">
                <label className="check-inline">
                  <input
                    type="checkbox"
                    name="whatsapp_quote_opt_in"
                    checked={form.whatsapp_quote_opt_in}
                    onChange={handleChange}
                  />
                  Opcional: acepto recibir solicitudes de cotización por WhatsApp de Cuadrilla Maestra.
                </label>
              </div>
            )}
            <button type="submit" className="btn btn-primary form-submit" disabled={loading}>
              {loading ? 'Creando cuenta...' : 'Crear cuenta'}
            </button>
          </form>
          <div className="form-divider"><span>o</span></div>
          <div className="google-btn">
            <GoogleLogin onSuccess={handleGoogle} onError={() => setError('No se pudo registrar con Google.')} text="signup_with" />
          </div>
          <div className="form-foot">
            <Link to="/registro">← Elegir otro tipo de cuenta</Link>
          </div>
          <div className="form-foot">
            ¿Ya tienes cuenta? <Link to="/login">Ingresa</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
